<template>
  <div>
    <div class="toolbar-agenda">
      <!-- <div v-if="visible"> -->
      <div>

        <template v-if="isPrazoVisible">
          <b-button
            v-b-tooltip.hover="'Sincronizar Projudi'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            @click="$bvModal.show('modal-recarregar')"
          >
            <span class="icon-blue"><svg-icon-refresh></svg-icon-refresh></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Limpar Cumpridos'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            @click="$bvModal.show('modal-limpar-prazos')"
          >
            <span class="icon-blue"
              ><svg-icon-limpar-minuta></svg-icon-limpar-minuta
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Calcular Prazo'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            @click="$bvModal.show('modal-calcular-prazo')"
          >
            <span class="icon-blue"><svg-icon-cog></svg-icon-cog></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Ver Prazos'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            @click="$bvModal.show('modal-tabela-vencimentos')"
          >
            <span class="icon-blue"
              ><svg-icon-ver-prazos></svg-icon-ver-prazos
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Informar Prazo Manual'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': itensSelecionados.length == 0 }"
            @click="abrirModalInformarPrazo()"
          >
            <span class="icon-blue"
              ><svg-icon-informar-prazo></svg-icon-informar-prazo
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Ver Movimentos'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': itensSelecionados.length != 1 }"
            @click="abrirModalVerMovimento()"
          >
            <span class="icon-blue"
              ><svg-icon-ver-movimento></svg-icon-ver-movimento
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Ver PDF'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': desabilitaVerPdf()}"
            @click="abrirModalVerPDF()"
          >
            <span class="icon-blue"><svg-icon-ver-pdf></svg-icon-ver-pdf></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Abrir Prazo'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': desabilitaAbriPrazo() }"
            @click="$bvModal.show('modal-abrir-prazo')"
          >
            <span class="icon-blue"
              ><svg-icon-abrir-prazo></svg-icon-abrir-prazo
            ></span>
          </b-button>
        </template>
        <template v-if="isProcessoVisible">
          <b-button
            v-b-tooltip.hover="'Ver CDAs'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': itensSelecionados.length != 1 }"
            @click="abrirModalVerCDA()"
          >
            <span class="icon-blue"><svg-icon-ver-cda></svg-icon-ver-cda></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Ver Dossiê'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': itensSelecionados.length != 1 }"
            @click="abrirModalVerDossie()"
          >
            <span class="icon-blue"
              ><svg-icon-dossie-devedor></svg-icon-dossie-devedor
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Pesquisa Trovale'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': itensSelecionados.length != 1 }"
            @click="abrirModalPesquisaTrovale()"
          >
            <span class="icon-blue"
              ><svg-icon-consulta-trovale></svg-icon-consulta-trovale
            ></span>
          </b-button>
        </template>
        <template v-if="isMinutaVisible">
          <b-button
            v-b-tooltip.hover="'Consulta Modelos'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            @click="$bvModal.show('modal-consultar-modelos')"
          >
            <span class="icon-blue"
              ><svg-icon-consulta-modelo></svg-icon-consulta-modelo
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Limpar Minuta'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': !verificarSelecionadoGerada() }"
            @click="abrirModalLimparMinuta()"
          >
            <span class="icon-blue"
              ><svg-icon-limpar-minuta></svg-icon-limpar-minuta
            ></span>
          </b-button>
          <b-button
            v-b-tooltip.hover="'Peticionar no Projudi'"
            pill
            variant="link"
            class="btn-toolbar-agenda"
            :class="{ 'icon-disabled': !verificarSelecionadoGeradaAberto() }"
            @click="abrirModalPeticionar()"
          >
            <span class="icon-blue"
              ><svg-icon-enviar-peticionamento></svg-icon-enviar-peticionamento
            ></span>
          </b-button>
        </template>
      </div>

      <b-button
        pill
        v-b-tooltip.hover="'Exibir/Ocultar Botões'"
        variant="link"
        class="btn-toolbar-adicionar"
        @click="showToolbar()"
      >
        <i class="fa fa-plus"></i>
      </b-button>
    </div>
  </div>
</template>

<script>
import SvgIconRefresh from "@/components/svg-icons/SvgIconRefresh.vue";
import SvgIconCog from "@/components/svg-icons/SvgIconCog.vue";
import SvgIconLimparMinuta from "@/components/svg-icons/SvgIconLimparMinuta.vue";
import SvgIconInformarPrazo from "@/components/svg-icons/SvgIconInformarPrazo.vue";
import SvgIconVerMovimento from "@/components/svg-icons/SvgIconVerMovimento.vue";
import SvgIconVerPdf from "@/components/svg-icons/SvgIconVerPdf.vue";
import SvgIconVerPrazos from "@/components/svg-icons/SvgIconVerPrazos.vue";
import SvgIconVerCda from "@/components/svg-icons/SvgIconVerCda.vue";
import SvgIconDossieDevedor from "@/components/svg-icons/SvgIconDossieDevedor.vue";
import SvgIconConsultaTrovale from "@/components/svg-icons/SvgIconConsultaTrovale.vue";
import SvgIconConsultaModelo from "@/components/svg-icons/SvgIconConsultaModelo.vue";
import SvgIconEnviarPeticionamento from "@/components/svg-icons/SvgIconEnviarPeticionamento.vue";
import SvgIconAbrirPrazo from "@/components/svg-icons/SvgIconAbrirPrazo.vue";

export default {
  components: {
    SvgIconRefresh,
    SvgIconCog,
    SvgIconLimparMinuta,
    SvgIconInformarPrazo,
    SvgIconVerMovimento,
    SvgIconVerPdf,
    SvgIconVerPrazos,
    SvgIconVerCda,
    SvgIconDossieDevedor,
    SvgIconConsultaTrovale,
    SvgIconConsultaModelo,
    SvgIconEnviarPeticionamento,
    SvgIconAbrirPrazo,
  },
  props: {
    perfil: {
      type: String,
      default: "prazo",
    },
    itensSelecionados: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      // visible: true,
      // clicks: 0,
      isPrazoVisible: true,
      isProcessoVisible: true,
      isMinutaVisible: true,
      allVisible: false,
      apenasGrupoAsses: false
    };
  },
  methods: {
    showToolbar() {
      this.allVisible = !this.allVisible;

      if (this.allVisible) {
        this.showAll();
      } else {
        this.hideOthers();
      }
    },
    showAll() {
      this.isPrazoVisible = true;
      this.isProcessoVisible = true;
      this.isMinutaVisible = true;
    },
    hideOthers() {
      switch (this.perfil) {
        case "processo": {
          this.isPrazoVisible = false;
          this.isProcessoVisible = true;
          this.isMinutaVisible = false;
          break;
        }
        case "minuta": {
          this.isPrazoVisible = false;
          this.isProcessoVisible = false;
          this.isMinutaVisible = true;
          break;
        }
        default: {
          //prazo
          this.isPrazoVisible = true;
          this.isProcessoVisible = false;
          this.isMinutaVisible = false;
          break;
        }
      }
    },
    test() {
      return this.perfil;
    },
    abrirModalInformarPrazo() {
      if (this.itensSelecionados.length > 0) {
        this.$bvModal.show('modal-vencimento-manual')
      }
    },
    abrirModalVerMovimento() {
      if (this.itensSelecionados.length == 1) {
        this.$bvModal.show('modal-ver-movimento')
      }
    },
    abrirModalVerPDF() {
      if (!this.desabilitaVerPdf() && this.itensSelecionados.length > 0) {
        this.$bvModal.show('modal-vinculado')
      }
    },
    abrirModalVerCDA() {
      if (this.itensSelecionados.length == 1) {
        this.$bvModal.show('modal-ver-cda')
      }
    },
    abrirModalVerDossie() {
      if (this.itensSelecionados.length == 1) {
        this.$bvModal.show('modal-ver-dossie')
      }
    },
    abrirModalPesquisaTrovale() {
      if (this.itensSelecionados.length == 1) {
        this.$bvModal.show('modal-pesquisa-trovale')
      }
    },
	abrirModalLimparMinuta() {
	  if (this.verificarSelecionadoGerada()) {
		this.$bvModal.show('modal-limpar-minuta')
	  }
	},
    abrirModalPeticionar() {
      if (this.verificarSelecionadoGeradaAberto()) {
        this.$bvModal.show('modal-peticionar')
      }
    },
    verificarSelecionadoGerada() {
	  if (this.itensSelecionados.length <= 0) {
		  return false
	  }
	  for (var selecionado of this.itensSelecionados) {
	    if (selecionado.statusMinuta.startsWith('Gerada')) {
		  return true
	    }
	  }
	  return false
    },
    verificarSelecionadoGeradaAberto() {
	  if (this.apenasGrupoAsses || this.itensSelecionados.length <= 0) {
		  return false
	  }
	  for (var selecionado of this.itensSelecionados) {
	    if (selecionado.statusMinuta.startsWith('Gerada')
		    && selecionado.statusPrazo === 'PENDENTE_RESPOSTA') {
		  return true
	    }
	  }
	  return false
    },
    desabilitaVerPdf() {
      if (this.itensSelecionados.length != 1) {
        return true
      }
      for (var selecionado of this.itensSelecionados) {
        if (selecionado.statusPrazo === 'PENDENTE_CIENCIA') {
          return true
        }
      }
      return false
    },
	verificarPermissaoUsuario() {
	  let userData = JSON.parse(this.$store.getters.getUser);
	  if (userData.groups) {
		  this.apenasGrupoAsses = true
		  let gruposPermitidos = ['PGEPROAJU-ADMINISTRADOR', 'PGEPROAJU-AGENDAPRAZO-PROC'];
		  for (let i = 0; i < userData.groups.length; i++) {
			  let grupoUsuario = userData.groups[i];

			  if (gruposPermitidos.indexOf(grupoUsuario) != -1) {
				  this.apenasGrupoAsses = false;
				  break;
			  }
		  }
	  }
	}	,
  desabilitaAbriPrazo() {
      if (this.itensSelecionados.length <= 0) {
        return true
      }

      for (var selecionado of this.itensSelecionados) {
        if (selecionado.sistemaFonte === 'EPROC') {
          return true
        }
      }
      return false
    },  
  },
  watch: {
    perfil: function() {
      this.hideOthers();
      //   this.showAll();
    },
  },
  mounted() {
    this.hideOthers();
	this.verificarPermissaoUsuario();
  },
};
</script>

<style lang="scss">
.toolbar-agenda {
  display: flex;
  justify-content: end;
  background-color: #ffffff;
  border-radius: 5rem;
  margin: 1rem 0;

  .btn-toolbar-agenda {
    font-size: 1.5rem;
  }

  .btn-toolbar-adicionar {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #e9e5e6;
    border: 5px solid;
    font-size: 2rem;
    padding: 0;
    height: 3rem;
    width: 3rem;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
}

.icon-disabled {
  opacity: 0.2;
  cursor: default !important;
}

.icon-blue svg {
  color: #205A76;
}

</style>
